import React from "react";
import { Link } from "react-router-dom";
import {
  isImageOnlyHeroHeadline,
  getInternalHeroPath,
} from "../constants/heroContent";
import "./HeroSection.css";

const HeroCta = ({ label, url, preview }) => {
  if (!label || !url) return null;

  const className = "btn red-btn hero-section__cta-btn";

  if (preview) {
    return (
      <span className={className} aria-hidden="true">
        {label}
      </span>
    );
  }

  const internalPath = getInternalHeroPath(url);
  if (internalPath) {
    return (
      <Link to={internalPath} className={className}>
        {label}
      </Link>
    );
  }

  return (
    <a href={url} className={className}>
      {label}
    </a>
  );
};

const HeroSection = ({
  headline,
  body,
  headlineColor,
  imageSrc,
  imageAlt = "Homepage hero",
  ctaLabel,
  ctaUrl,
  preview = false,
  onImageError,
}) => {
  const showCta = Boolean(String(ctaLabel || "").trim() && String(ctaUrl || "").trim());
  const imageOnly = isImageOnlyHeroHeadline(headline);
  const sectionClass = `hero-section${preview ? " hero-section--preview" : " my-5"}${
    imageOnly ? " hero-section--image-only" : ""
  }`;

  if (imageOnly) {
    return (
      <section className={sectionClass}>
        <div className={preview ? "container-fluid px-3" : "container"}>
          <div className="hero-section__media hero-section__media--solo">
            <img
              src={imageSrc}
              alt={imageAlt}
              referrerPolicy="no-referrer"
              onError={onImageError}
            />
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className={sectionClass}>
      <div className={preview ? "container-fluid px-3" : "container"}>
        <div className="row hero-section__row">
          <div className="col-12 col-lg-6">
            <div className="hero-section__copy">
              <h1
                className="hero-section__headline mb-2"
                style={{ color: headlineColor }}
              >
                {headline}
              </h1>
              {body ? <p className="large hero-section__body">{body}</p> : null}
              {showCta ? (
                <div className="hero-section__cta">
                  <HeroCta label={ctaLabel} url={ctaUrl} preview={preview} />
                </div>
              ) : null}
            </div>
          </div>
          <div className="col-12 col-lg-6">
            <div className="hero-section__media">
              <img
                src={imageSrc}
                alt={imageAlt}
                referrerPolicy="no-referrer"
                onError={onImageError}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
